export function isCanceledError(e) {
    return e.isCancelError === true;
}
self.addEventListener('error', e => {
    return isCanceledError(e.error);
});
export default class CanceledError extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'Canceled');
        this.isCancelError = true;
    }
}
